export default __webpack_public_path__ + "static/media/eng_2.af07f45b.png";